import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { poppinsCustomTheme } from "../../Styles/GlobalStyles/PoppinsTheme";
import { ThemeProvider } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import { DialogGreyOutlinedButton } from "../Button/CustomButton";
import { colors } from "../../Styles/GlobalStyles/Variables";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Button,
  Divider,
  FormControl,
  IconButton,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import HorizontalLinearStepper from "./StoryHorizontalTabs";
import { Box } from "@mui/system";
import Image from "../MangeSuccessfulBusiness/Images/image3.png";
import ViewandEditForm from "./ViewandEditForm";
import { EditIcon } from "../MuiDataTableTheme/MuiDataTableTheme";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import {
  StyledDialogActions,
  StyledDialogTitle,
  StyledLeftBox,
  StyledRightBox,
} from "../MangeSuccessfulBusiness/dialogStyles/DialogStyles";
import {
  emptyCorpsMember,
  restoreStoryInitial,
  updateSuccessStory,
  approveSuccessStory,
} from "../../Actions";
import { errors } from "../../Utils/ErrorMessages/story";
import ConfirmDialog from "../Alert/ConfirmDialog";
const getUsersState = (state) => state.usersReducer;
const getStoryState = (state) => state.successStoryReducer;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const getCMState = (state) => state.usersReducer;

export default function AddNewStoryDialog({
  openNewStoryDialog,
  handleClose,
  formType,
  handleOpenEditStoryDialog,
  singleStoryData,
  isClosedDialog,
  resetState,
}) {
  const ToastStyle = {
    backgroundColor: "#d56b66",
    color: colors.white,
  };

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    isLoading: false,
    title: "",
    subTitle: "",
    header: "",
    backgroundColor: "",
    borderSideColor: "",
    color: "",
    subColor: "",
    note: false,
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const initialFormValues = {
    story: "",
  };
  const initialFormState = {
    storyError: false,
    storyErrorMsg: "",
  };
  const initialInputValues = {
    successStoryId: 0,
    isApprove: true,
    comment: "",
  };
  const initialInputState = {
    commentError1: false,
    commentError2: false,
    commentError3: false,
    commentErrorMsg1: "",
    commentErrorMsg2: "",
    commentErrorMsg3: "",
  };
  const [formValues, setFormValues] = useState({ ...initialFormValues });
  const [inputValues, setInputValues] = useState({ ...initialInputValues });
  const [loadingButton, setLoadingButton] = useState(false);
  const [isFoundCM, setIsFoundCM] = useState(false);
  const [isError, setIsError] = useState(false);
  const { corpsmemberDetails, isLoading } = useSelector(getCMState);
  const { loadingUpdated, storyApproved } = useSelector(getStoryState);
  const { authUser } = useSelector(getUsersState);
  const [formStates, setFormStates] = useState(initialFormState);
  const [inputStates, setInputStates] = useState(initialInputState);
  const [datas, setDatas] = useState("");
  const [exCM, setExCM] = useState({});
  const [showSkeleton, setShowSkeleton] = useState(true);

  const resetFoundCM = () => {
    setIsFoundCM(false);
  };

  useEffect(() => {
    if (corpsmemberDetails?.data !== null) {
      setExCM(corpsmemberDetails?.data);
    } else {
      setIsFoundCM(false);
    }
  }, [corpsmemberDetails]);
  useEffect(() => {
    if (Object.keys(singleStoryData)?.length !== 0) {
      setDatas(singleStoryData);
      setShowSkeleton(false);
    } else {
      setShowSkeleton(true);
    }
  }, [singleStoryData]);

  const showError = () => {
    setIsError(true);
  };
  const showNoError = () => {
    setIsError(false);
  };
  useEffect(() => {
    if (datas) {
      setFormValues({
        ...formValues,
        story: datas?.story,
      });
      setInputValues({
        ...inputValues,
        successStoryId: datas?.id,
      });
    }
  }, [datas]);

  const handleStoryUpdate = (event) => {
    const { name, value } = event.target;
    let newValue = value;
    setFormValues({
      ...formValues,
      [name]: newValue,
    });
    switch (name) {
      case "story":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            storyError: true,
            storyErrorMsg: errors.story,
          });
        } else {
          setFormStates({
            ...formStates,
            storyError: false,
            storyErrorMsg: "",
          });
        }
        break;

      default:
        break;
    }
  };
  const handleCommentChange = (event, identifier) => {
    const { name, value } = event.target;
    let newValue = value;
    setInputValues({
      ...inputValues,
      [name]: newValue,
    });
    switch (name) {
      case "comment":
        if (newValue === "") {
          setInputStates({
            ...inputStates,
            [`commentError${identifier}`]: true,
            [`commentErrorMsg${identifier}`]: errors.comment,
          });
        } else {
          setInputStates({
            ...inputStates,
            [`commentError${identifier}`]: false,
            [`commentErrorMsg${identifier}`]: "",
          });
        }
        break;

      default:
        break;
    }
  };

  const handleFormUpdate = () => {
    if (Object.values(formValues).every((value) => value !== "")) {
      setLoadingButton(true);
      const payload = {
        id: singleStoryData?.id,
        body: formValues,
      };
      dispatch(updateSuccessStory(payload));
    } else {
      if (formValues.story === "") {
        setFormStates({
          ...formStates,
          storyError: formValues.story === "",
          storyErrorMsg: formValues.story === "" ? errors.story : "",
        });
      }
    }
  };

  const handleApprove = () => {
    dispatch(approveSuccessStory(inputValues));
    setConfirmDialog({
      ...confirmDialog,
      // isOpen: false,
      isLoading: true,
    });
  };

  const handleApproveError = () => {
    let commentIdentifier;

    if (authUser?.role === "SAED_State") {
      commentIdentifier = 1;
    } else if (authUser?.role === "SAED_State_Coordinator") {
      commentIdentifier = 2;
    } else if (authUser?.role === "SAED_NDHQ") {
      commentIdentifier = 3;
    } else {
      commentIdentifier = 0;
    }

    if (Object.values(inputValues).every((value) => value !== "")) {
      setConfirmDialog({
        isOpen: true,
        title: `Are you sure you want to approve ${singleStoryData.cmName}'s success story?`,
        header: "Approve Success Story",
        color: colors.primaryGreen,
        subColor: colors.successDialogSubTitle,
        onConfirm: handleApprove,
      });
    } else {
      handleCommentChange(
        {
          target: {
            name: "comment",
            value: inputValues.comment,
          },
        },
        commentIdentifier
      );
    }
  };

  const handleRejectError = () => {
    let commentIdentifier;

    if (authUser?.role === "SAED_State") {
      commentIdentifier = 1;
    } else if (authUser?.role === "SAED_State_Coordinator") {
      commentIdentifier = 2;
    } else if (authUser?.role === "SAED_NDHQ") {
      commentIdentifier = 3;
    } else {
      commentIdentifier = 0;
    }

    if (Object.values(inputValues).every((value) => value !== "")) {
      setConfirmDialog({
        isOpen: true,
        title: `Are you sure you want to reject ${singleStoryData.cmName}'s success story?`,
        header: "Reject Success Story",
        color: colors.primaryGreen,
        subColor: colors.successDialogSubTitle,
        onConfirm: handleReject,
      });
    } else {
      handleCommentChange(
        {
          target: {
            name: "comment",
            value: inputValues.comment,
          },
        },
        commentIdentifier
      );
    }
  };

  const handleReject = () => {
    debugger;
    const rejectInput = {
      ...inputValues,
      isApprove: false,
    };
    dispatch(approveSuccessStory(rejectInput));
    setConfirmDialog({
      ...confirmDialog,
      isLoading: true,
    });
  };

  useEffect(() => {
    if (storyApproved === true) {
      setConfirmDialog({
        ...confirmDialog,
        isLoading: false,
        isOpen: false,
      });
      handleCloseDialog();
    }
    return () => {
      dispatch(restoreStoryInitial());
    };
  }, [storyApproved]);

  useEffect(() => {
    if (loadingButton && !loadingUpdated) {
      setLoadingButton(false);
    }
    return () => {
      dispatch(restoreStoryInitial());
    };
  }, [loadingButton, loadingUpdated]);

  const handleEdit = () => {
    handleOpenEditStoryDialog();
  };
  const handleIsFoundCM = () => {
    setIsFoundCM(true);
  };
  const handleResetFoundCM = () => {
    setIsFoundCM(false);
    dispatch(emptyCorpsMember());
  };
  const handleCloseDialog = () => {
    handleResetFoundCM();
    handleClose();
    setFormStates({ ...initialFormState });
    setInputStates({ ...initialInputState });
    setIsError(true);
  };

  return (
    <ThemeProvider theme={poppinsCustomTheme}>
      <Dialog
        fullWidth={true}
        fullScreen={fullScreen}
        maxWidth={"md"}
        open={openNewStoryDialog}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          style: { borderRadius: 20, overflow: "hidden", height: "100%" },
        }}
      >
        <Box
          height="100%"
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          sx={{
            [theme.breakpoints.down("md")]: {
              flexDirection: "column",
            },
          }}
        >
          <StyledLeftBox>
            {isFoundCM || formType !== "add" ? (
              <Box sx={{ mt: "20px" }}>
                {/* <StyledDivider textAlign="left"> */}
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#949494", ml: 1 }}
                >
                  Ex Corps Member Profile
                </Typography>
                {/* </StyledDivider> */}
                <FormControl sx={{ margin: "20px 10px" }}>
                  {(formType === "edit" || formType === "view") &&
                  showSkeleton ? (
                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      height={40}
                      width={200}
                    />
                  ) : (
                    <TextField
                      id="standard-read-only-input"
                      label="Full Name"
                      value={
                        formType === "add"
                          ? exCM?.cmName
                          : formType === "view" || formType === "edit"
                          ? singleStoryData?.cmName
                          : ""
                      }
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="standard"
                    />
                  )}
                </FormControl>
                <FormControl sx={{ margin: "20px 10px" }}>
                  {(formType === "edit" || formType === "view") &&
                  showSkeleton ? (
                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      height={40}
                      width={200}
                    />
                  ) : (
                    <TextField
                      id="standard-read-only-input"
                      label={
                        formType !== "add" ? "Business Name" : "Business Name"
                      }
                      value={
                        formType === "add"
                          ? exCM?.businessName
                          : formType === "view" || formType === "edit"
                          ? singleStoryData?.businessName
                          : ""
                      }
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="standard"
                    />
                  )}
                </FormControl>
                <FormControl sx={{ margin: "20px 10px" }}>
                  {(formType === "edit" || formType === "view") &&
                  showSkeleton ? (
                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      height={40}
                      width={200}
                    />
                  ) : (
                    <TextField
                      id="standard-read-only-input"
                      label={
                        formType !== "add" ? "Skill Acquired" : "Skill Acquired"
                      }
                      value={
                        formType === "add"
                          ? exCM?.skill
                          : formType === "view" || formType === "edit"
                          ? singleStoryData?.skill?.name
                          : ""
                      }
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="standard"
                    />
                  )}
                </FormControl>

                <FormControl sx={{ margin: "20px 10px" }}>
                  {(formType === "edit" || formType === "view") &&
                  showSkeleton ? (
                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      height={40}
                      width={200}
                    />
                  ) : (
                    <TextField
                      id="standard-read-only-input"
                      label="Training Center"
                      value={
                        formType === "add"
                          ? exCM?.trainingCenterName
                          : formType === "view" || formType === "edit"
                          ? singleStoryData?.trainingCenterName
                          : ""
                      }
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="standard"
                    />
                  )}
                </FormControl>
              </Box>
            ) : formType === "add" ? (
              <img
                src={Image}
                alt=""
                style={{ height: "300px", width: "auto" }}
              />
            ) : (
              "hell0"
            )}
          </StyledLeftBox>
          <div style={StyledRightBox}>
            <StyledDialogTitle id="responsive-dialog-title">
              {formType === "add"
                ? "Add New Success Story"
                : formType === "view"
                ? "View Success Story"
                : formType === "edit"
                ? "Edit Success Story"
                : ""}
              <IconButton onClick={handleCloseDialog}>
                <CloseIcon />
              </IconButton>
            </StyledDialogTitle>
            <Divider />
            <DialogContent
              sx={{ padding: "20px 10px", textTransform: "capitalize" }}
            >
              {formType === "add" ? (
                <HorizontalLinearStepper
                  resetFoundCM={resetFoundCM}
                  isFoundCM={isFoundCM}
                  handleIsFoundCM={handleIsFoundCM}
                  handleResetFoundCM={handleResetFoundCM}
                  handleCloseDialog={handleCloseDialog}
                  isClosedDialog={isClosedDialog}
                  resetState={resetState}
                  showError={showError}
                  showNoError={showNoError}
                  isError={isError}
                />
              ) : formType === "view" || "edit" ? (
                <ViewandEditForm
                  formType={formType}
                  singleStoryData={singleStoryData}
                  formValues={formValues}
                  inputValues={inputValues}
                  handleStoryUpdate={handleStoryUpdate}
                  handleCommentChange={handleCommentChange}
                  formStates={formStates}
                  inputStates={inputStates}
                  showSkeleton={showSkeleton}
                />
              ) : (
                ""
              )}
            </DialogContent>
            <Divider />
            {formType === "add" ? (
              ""
            ) : (
              <StyledDialogActions>
                {(formType === "view" && authUser?.role === "SAED_LGI") ||
                singleStoryData?.approvalStatus >= 5 ? (
                  <DialogGreyOutlinedButton
                    sx={{
                      textTransform: "capitalize",
                      padding: "10px 30px",
                      margin: "10px",
                    }}
                    onClick={handleCloseDialog}
                  >
                    close
                  </DialogGreyOutlinedButton>
                ) : formType === "view" && authUser?.role !== "SAED_LGI" ? (
                  <Button
                    onClick={handleRejectError}
                    sx={{
                      textTransform: "capitalize",
                      bgcolor: "#C31D1D",
                      borderColor: "#C31D1D",
                      color: "#fff",
                      padding: "10px 30px",
                      margin: "10px",
                      "&:hover": { bgcolor: "#C31D1D" },
                    }}
                    variant="outlined"
                  >
                    {authUser?.role === "SAED_NDHQ" &&
                    authUser?.role !== "SAED_LGI"
                      ? "Reject"
                      : "Recommend for Rejection"}
                  </Button>
                ) : (
                  ""
                )}
                {formType === "view" &&
                singleStoryData?.approvalStatus === 0 &&
                authUser?.role === "SAED_LGI" ? (
                  <Button
                    onClick={handleEdit}
                    startIcon={<EditIcon icon="icon-park-outline:edit" />}
                    sx={{
                      textTransform: "capitalize",
                      color: colors.primaryYellow,
                      borderColor: colors.primaryYellow,
                      padding: "10px 30px",
                      margin: "10px",
                      "&:hover": { borderColor: colors.primaryYellow },
                    }}
                    variant="outlined"
                  >
                    Edit Details
                  </Button>
                ) : formType === "view" &&
                  authUser?.role !== "SAED_LGI" &&
                  singleStoryData?.approvalStatus < 5 ? (
                  <Button
                    onClick={handleApproveError}
                    sx={{
                      textTransform: "capitalize",
                      color: "#fff",
                      bgcolor: colors.primaryGreen,
                      borderColor: colors.primaryGreen,
                      padding: "10px 28px",
                      margin: "10px",
                      "&:hover": {
                        bgcolor: colors.primaryGreen,
                        borderColor: colors.primaryGreen,
                      },
                    }}
                    variant="outlined"
                  >
                    {authUser?.role === "SAED_NDHQ" &&
                    authUser?.role !== "SAED_LGI"
                      ? "Approve"
                      : "Recommend for Approval"}
                  </Button>
                ) : formType === "edit" ? (
                  <LoadingButton
                    loading={loadingButton}
                    loadingIndicator="Saving..."
                    onClick={handleFormUpdate}
                    disableElevation
                    startIcon={<SaveAsIcon icon="icon-park-outline:edit" />}
                    sx={{
                      textTransform: "capitalize",
                      color: "#fff",
                      borderColor: colors.primaryGreen,
                      "&:hover": { borderColor: colors.primaryGreen },
                      padding: "10px 30px",
                      margin: "10px",
                    }}
                    variant="contained"
                  >
                    Save Changes
                  </LoadingButton>
                ) : (
                  ""
                )}
              </StyledDialogActions>
            )}
          </div>
        </Box>
        <ToastContainer toastStyle={ToastStyle} />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </Dialog>
    </ThemeProvider>
  );
}
